import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { staticConfig } from "../../customer/customer.config";
import { chargeApi, chargeLabel, chargeStatic } from "./charge.config";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;
const dateFormat = "YYYY/MMMM/DD";

const NewCharge = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newChargeItems } = chargeStatic;
  const [form] = Form.useForm();

  const chargeApplyToCurrent = Form.useWatch("chargeAppliesTo", form);
  const chargeTimeType = Form.useWatch("chargeTimeType", form);
  const enablePaymentType = Form.useWatch("enablePaymentType", form);
  const enableFreeWithdrawalCharge = Form.useWatch(
    "enableFreeWithdrawalCharge",
    form
  );
  const [currencyData, setCurrencyData] = useState([]);
  const [chargeApplyData, setChargeApplyData] = useState([]);
  const [chargeMethodData, setChargeMethodData] = useState([]);
  const [chargeCalcTypeData, setChargeCalcTypeData] = useState([]);
  const [filteredChargeCalcTypeData, setFilteredChargeCalcTypeData] = useState(
    []
  );
  const [filteredChargeTimeTypeData, setFilteredChargeTimeTypeData] = useState(
    []
  );
  const [chargeTimeTypeData, setChargeTimeTypeData] = useState([]);
  const [chargeTemplateData, setChargeTemplateData] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [feeFrequencyOptions, setFeeFrequencyOptions] = useState([]);
  const [incomeFromChargeOptions, setIncomeFromChargeOptions] = useState([]);
  const [tempLoanCharge, setTempLoanCharge] = useState([]);
  const [tempLoanCalc, setTempLoanCalc] = useState([]);
  const [tempSavingsCharge, setTempSavingsCharge] = useState([]);
  const [tempSavingsCalc, setTempSavingsCalc] = useState([]);
  const [tempClientCharge, setTempClientCharge] = useState([]);
  const [tempClientCalc, setTempClientCalc] = useState([]);
  const [tempSharesCharge, setTempSharesCharge] = useState([]);
  const [tempSharesCalc, setTempSharesCalc] = useState([]);
  const [tempTreasuryCharge, setTempTreasuryCharge] = useState([]);
  const [tempTreasuryCalc, setTempTreasuryCalc] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMonthlyFee, setIsMonthlyFee] = useState(false);
  const [isAnnualFee, setIsAnnualFee] = useState(false);
  const [isWeeklyFee, setIsWeeklyFee] = useState(false);
  const [isWithdrawalFee, setIsWithdrawalFee] = useState(false);
  const [appliesToLoan, setAppliesToLoan] = useState(true);

  useEffect(() => {
    getTemplate();
    getPaymentTypes();
  }, []);
  useEffect(() => {
    switch (chargeApplyToCurrent) {
      case 1:
        setFilteredChargeCalcTypeData(tempLoanCalc);
        setFilteredChargeTimeTypeData(tempLoanCharge);
        break;
      case 2:
        setFilteredChargeCalcTypeData(tempSavingsCalc);
        setFilteredChargeTimeTypeData(tempSavingsCharge);
        break;
      case 3:
        setFilteredChargeCalcTypeData(tempClientCalc);
        setFilteredChargeTimeTypeData(tempClientCharge);
        break;
      case 4:
        setFilteredChargeCalcTypeData(tempSharesCalc);
        setFilteredChargeTimeTypeData(tempSharesCharge);
        break;
      case 5:
        setFilteredChargeCalcTypeData(tempTreasuryCalc);
        setFilteredChargeTimeTypeData(tempTreasuryCharge);
        break;
      case 6:
        setFilteredChargeCalcTypeData([]);
        setFilteredChargeTimeTypeData([]);
        break;
      default:
        return;
    }
    form.setFieldsValue({
      chargeTimeType: undefined,
      chargeCalculationType: undefined,
    });
  }, [chargeApplyToCurrent]);

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };
  function getTemplate() {
    const url = `${chargeApi.Charges}/template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempChargeApply = [];
        let tempChargeCalcType = [];
        let tempChargeTimeType = [];
        let tempChargeMethod = [];
        let tempCurrency = [];
        let tempTaxGroupOptions = [];
        let tempIncomeFromChargeOptions = [];
        let tempFeeFrequencyOptions = [];
        let tempLoanCharge = [];
        let tempLoanCalc = [];
        let tempSavingsCharge = [];
        let tempSavingsCalc = [];
        let tempClientCharge = [];
        let tempClientCalc = [];
        let tempSharesCharge = [];
        let tempSharesCalc = [];
        let tempTreasuryCharge = [];
        let tempTreasuryCalc = [];

        objList?.chargeAppliesToOptions.forEach((element) => {
          tempChargeApply.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        objList?.chargeCalculationTypeOptions?.forEach((element) => {
          tempChargeCalcType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chargeTimeTypeOptions?.forEach((element) => {
          tempChargeTimeType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.chargePaymetModeOptions?.forEach((element) => {
          tempChargeMethod.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.incomeOrLiabilityAccountOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeFromChargeOptions.push({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            });
          }
        );

        objList?.feeFrequencyOptions
          ?.filter((item) => item?.value !== "Invalid")
          .forEach((element) => {
            tempFeeFrequencyOptions.push({
              value: element.id,
              label: element.value,
            });
          });
        objList?.loanChargeCalculationTypeOptions?.forEach((element) => {
          tempLoanCalc.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.loanChargeTimeTypeOptions?.forEach((element) => {
          tempLoanCharge.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.savingsChargeCalculationTypeOptions?.forEach((element) => {
          tempSavingsCalc.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.savingsChargeTimeTypeOptions?.forEach((element) => {
          tempSavingsCharge.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.clientChargeCalculationTypeOptions?.forEach((element) => {
          tempClientCalc.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.clientChargeTimeTypeOptions?.forEach((element) => {
          tempClientCharge.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.shareChargeCalculationTypeOptions?.forEach((element) => {
          tempSharesCalc.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.shareChargeTimeTypeOptions?.forEach((element) => {
          tempSharesCharge.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.treasuryChargeCalculationTypeOptions?.forEach((element) => {
          tempTreasuryCalc.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.treasuryChargeTimeTypeOptions?.forEach((element) => {
          tempTreasuryCharge.push({
            value: element.id,
            label: element.value,
          });
        });

        setTempLoanCharge(tempLoanCharge);
        setTempLoanCalc(tempLoanCalc);
        setTempSavingsCalc(tempSavingsCalc);
        setTempSavingsCharge(tempSavingsCharge);
        setTempClientCalc(tempClientCalc);
        setTempClientCharge(tempClientCharge);
        setTempSharesCharge(tempSharesCharge);
        setTempSharesCalc(tempSharesCalc);
        setTempTreasuryCharge(tempTreasuryCharge);
        setTempTreasuryCalc(tempTreasuryCalc);
        setCurrencyData(tempCurrency);
        setChargeApplyData(tempChargeApply);
        setChargeMethodData(tempChargeMethod);
        setTaxGroupOptions(tempTaxGroupOptions);
        setIncomeFromChargeOptions(tempIncomeFromChargeOptions);
        setChargeTemplateData(objList);
        setFeeFrequencyOptions(tempFeeFrequencyOptions);

        setChargeCalcTypeData(tempChargeCalcType);
        setChargeTimeTypeData(tempChargeTimeType);

        form.setFieldsValue({
          feeOnMonthDay: dayjs(),
        });

        setIsLoading(false);
      }
    });
  }
  function getPaymentTypes() {
    const url = chargeApi.Paymenttypes;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        let tempPaymentType = [];

        objList?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypeOptions(tempPaymentType);

        setIsLoading(false);
      }
    });
  }

  //DO NOT DELETE THE VALUE PARAM IN THE FOLLOWING FUNCTION
  const handleChargeTypeChange = (value, option) => {
    console.log(value);
    switch (option?.label.toLowerCase()) {
      case "monthly fee":
        setIsMonthlyFee(true);
        setIsAnnualFee(true);
        setIsWeeklyFee(true);
        setIsWithdrawalFee(false);
        break;
      case "annual fee":
        setIsAnnualFee(true);
        setIsMonthlyFee(true);
        setIsWeeklyFee(false);
        setIsWithdrawalFee(false);
        break;
      case "weekly fee":
        setIsWeeklyFee(true);
        setIsMonthlyFee(true);
        setIsAnnualFee(false);
        setIsWithdrawalFee(false);
        break;
      case "withdrawal fee":
        setIsWithdrawalFee(true);
        break;
      // case "overdue fees":
      //   setIsOverdueFees(true);
      // break;
      default:
        setIsMonthlyFee(false);
        setIsAnnualFee(false);
        setIsWeeklyFee(false);
        // setIsOverdueFees(false);
        setIsWithdrawalFee(false);
    }
  };

  function onCancel() {
    navigate("/prd1000", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues.feeOnMonthDay = BOM.DateTimeWithoutYear(
      formValues.feeOnMonthDay,
      "only-date"
    );

    if (formValues.chargeTimeType !== 6 && formValues.chargeTimeType !== 7) {
      delete formValues.feeOnMonthDay;
    }
    delete formValues.addfeefrequency;

    const body = {
      ...formValues,
      locale: "en",
      monthDayFormat: "dd MMM",
      enableFreeWithdrawalCharge: false,
      enablePaymentType: false,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      chargeApi.Charges,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, chargeLabel.newChargeMsg);
          navigate("/charge-detail", { state: { id: res.resourceId } });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd1000");
          setIsLoading(false);
        },
      }
    );
  };

  const disabledPastDate = (current) => {
  // Disable dates before today
  return current && current.isBefore(dayjs().startOf("day"));
};

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={chargeLabel.newCharge}
        pageItems={newChargeItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              penalty: false,
              enableFreeWithdrawalCharge: false,
              enablePaymentType: false,
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {chargeLabel.chargeSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeAppliesTo}
                  name="chargeAppliesTo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeAppliesTo),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeAppliesTo} *`,
                      "select"
                    )}
                    options={chargeApplyData}
                    // onChange={onChooseChargeApplyTo}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeName}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeName),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      chargeLabel.chargeName
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.currency}
                  name="currencyCode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.currency),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.currency} *`,
                      "select"
                    )}
                    options={currencyData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.amount}
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.amount),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(chargeLabel.amount)}
                    style={{ width: "100%", ...styles.ofInputFieldNumber }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeTimeType}
                  name="chargeTimeType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(chargeLabel.chargeTimeType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeTimeType} *`,
                      "select"
                    )}
                    options={filteredChargeTimeTypeData}
                    onChange={handleChargeTypeChange}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {isWithdrawalFee && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.enablePaymentType}
                      name="enablePaymentType"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.enablePaymentType}`,
                          "select"
                        )}
                        options={chargeStatic.statusData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  {enablePaymentType && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={chargeLabel.paymentTypes}
                        name="paymentTypeId"
                      >
                        <Select
                          placeholder={BOM.handlePlaceholderMsg(
                            `${chargeLabel.paymentTypes} *`,
                            "select"
                          )}
                          options={paymentTypeOptions}
                          // onChange={handleChargeTypeChange}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.enableFreeWithdrawal}
                      name="enableFreeWithdrawalCharge"
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.enableFreeWithdrawal}`,
                          "select"
                        )}
                        options={chargeStatic.statusData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  {enableFreeWithdrawalCharge && (
                    <>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.noOfFreeWithdrawals}
                          name="freeWithdrawalFrequency"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.noOfFreeWithdrawals
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={BOM.handlePlaceholderMsg(
                              chargeLabel.noOfFreeWithdrawals
                            )}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.restartCountingEvery}
                          name="restartCountFrequency"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.restartCountingEvery
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={BOM.handlePlaceholderMsg(
                              chargeLabel.restartCountingEvery
                            )}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          label={chargeLabel.restartCountFrequency}
                          name="countFrequencyType"
                          rules={[
                            {
                              required: true,
                              message: BOM.CheckReqFld(
                                chargeLabel.restartCountFrequency
                              ),
                            },
                          ]}
                        >
                          <Select
                            placeholder={BOM.handlePlaceholderMsg(
                              `${chargeLabel.restartCountFrequency} *`,
                              "select"
                            )}
                            options={feeFrequencyOptions}
                            showSearch
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.status} name="active">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.status}`,
                      "select"
                    )}
                    options={chargeStatic.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.isPenalty} name="penalty">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.isPenalty}`,
                      "select"
                    )}
                    options={chargeStatic.trueFalseData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.chargeCalculationType}
                  name="chargeCalculationType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        chargeLabel.chargeCalculationType
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.chargeCalculationType} *`,
                      "select"
                    )}
                    options={filteredChargeCalcTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {chargeApplyToCurrent === 1 && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={chargeLabel.chargePaymentMode}
                    name="chargePaymentMode"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(chargeLabel.chargePaymentMode),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        `${chargeLabel.chargePaymentMode} *`,
                        "select"
                      )}
                      options={chargeMethodData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              {isMonthlyFee && (
                <>
                  {isAnnualFee && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={chargeLabel.dueDate}
                        name="feeOnMonthDay"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(chargeLabel.dueDate),
                          },
                        ]}
                      >
                        <DatePicker
                          disabledDate={disabledPastDate}
                          style={{ width: "100%", height: 32.5 }}
                          format={dateFormat}
                          placeholder={BOM.handlePlaceholderMsg(
                            chargeLabel.dueDate,
                            "select"
                          )}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {isWeeklyFee && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={`${chargeLabel.repeatsEvery} ${
                          !isAnnualFee ? "Week" : "Months"
                        }`}
                        name="feeInterval"
                        rules={[
                          {
                            required: true,
                            message: BOM.CheckReqFld(chargeLabel.repeatsEvery),
                          },
                        ]}
                      >
                        <Input
                          placeholder={BOM.handlePlaceholderMsg(
                            "interval period"
                          )}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </>
              )}
              {appliesToLoan && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={chargeLabel.incomeFromCharge}
                    name="incomeAccountId"
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        `${chargeLabel.incomeFromCharge} *`,
                        "select"
                      )}
                      options={incomeFromChargeOptions}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}

              {/* {isOverdueFees && ( */}
              {/* <Col Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={chargeLabel.addFeeFrequency}
                  name="addfeefrequency"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.addFeeFrequency} *`,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                  />
                </Form.Item>
              </Col> */}
              {/* )} */}

              {/* {addFeeFrequencyCheck && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.chargeFrequency}
                      name="countFrequencyType"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(chargeLabel.chargeFrequency),
                        },
                      ]}
                    >
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          `${chargeLabel.chargeFrequency} *`,
                          "select"
                        )}
                        options={feeFrequencyOptions}
                        showSearch
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={chargeLabel.frequencyInterval}
                      name="feeInterval"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(
                            chargeLabel.frequencyInterval
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(
                          chargeLabel.frequencyInterval
                        )}
                      />
                    </Form.Item>
                  </Col>
                </>
              )} */}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={chargeLabel.taxGroup} name="taxGroupId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${chargeLabel.taxGroup} *`,
                      "select"
                    )}
                    options={taxGroupOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_CHARGE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewCharge);
